import React from 'react';
import properties from "../../../../src/modules/ajio-util/properties";
import { gtmEventPush } from '../../../../src/modules/ga/GTMdatalayer';
import luxeScreen from '../../../../src/refresh/constants/luxeScreenType';
import { gtmEventPushPLP } from '../../../modules/ga/GTMdatalayer';
class Logo extends React.Component {
  onLogoClick = () => {
    this.sendGtmEvent(
      'logo_click',
      'user interactions',
      'logo_click',
      'header'
    )
    gtmEventPushPLP({
      event: 'plp_navigation_interaction',
      event_category: 'plp_interaction',
      event_action: 'go to home',
      event_label: 'go to home',
      store_type: 'ajio',
      page_type: window.pageType || ''
    }, 'plp_navigation_interaction', true);
  }

  sendGtmEvent = (eventName, eventCategory, eventAction, eventLabel) => {
    const { navigation: { screenType = '', screenName = '' } = {}, luxeStore = '' } = luxeScreen;
    gtmEventPush({
      event: eventName,
      event_category: eventCategory,
      event_action: eventAction,
      event_label: eventLabel,
      store_type: luxeStore,
      page_name: screenName,
      page_type: screenType
    });
  };

  render() {
    let { sis = false, newDesignLuxe, isRetryPayment, isStreetStore } = this.props;
    // const prevSelectedCore = localStorage.getItem("categoryPath");
    // const coreName = prevSelectedCore ? prevSelectedCore.substring(prevSelectedCore.lastIndexOf("/") + 1, prevSelectedCore.length) : null;
    let parenturl = properties.getProperty('parentUrl');
    let logoURL = `${properties.getProperty('imageBaseUrl')}/static/img/Ajio-Logo.svg`;
    let luxelogoURL = `${properties.getProperty('imageBaseUrl')}/static/img/ajioluxe-logo.png`;
    let streetLogoURL = `${properties.getProperty('imageBaseUrl')}/static/img/ajio-street-logo.png`;
    return (
      <div className={`logo-float ${isRetryPayment && 'retryPayment-logo'}`}>
        <a
          href={sis && !newDesignLuxe && !isStreetStore ? parenturl : '/'}
          onClick={this.onLogoClick}
        >
          {newDesignLuxe ? (
            <img src={luxelogoURL} alt="Luxe logo" title="" />
          ) : isStreetStore ? (
            <img width="210px" src={streetLogoURL} alt="Ajio street logo" title="" />
          ) : (
            <img width="130px" src={logoURL} alt="Ajio logo" title="" />
          )}
        </a>
        {/* {coreName?<span className="core-selected">{coreName}</span>:null}           */}
      </div>
    );
  }
}

export default Logo;
